import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const ArrowRight = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="80" viewBox="0 0 80 74" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M46.3791 0.904001L79.9282 37.0883L46.3791 73.2717V56.5821H0.0639954V17.5946H46.3791V0.904001Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
